import { vehiclesColumns } from 'common/list-configs/vehicles.config';

const {
  owner,
  facilityCode,
  deviceId,
  year,
  make,
  model,
  licenseNumber,
  licenseState,
  smartPlateId,
  color,
  rantingDates,
  validityPeriod: validationDates,
  status,
  additionalInformation,
  parkSpaceNumber,
  registrationAddress,
  cardAccessLastActivityDate,
  dateVehicleAdded,
} = vehiclesColumns();
export const vehicleInitialColumns = [
  owner,
  facilityCode,
  deviceId,
  year,
  make,
  model,
  licenseNumber,
  licenseState,
  smartPlateId,
  { ...color, hidden: true },
  rantingDates,
  validationDates,
  status,
  additionalInformation,
  parkSpaceNumber,
  registrationAddress,
  cardAccessLastActivityDate,
  dateVehicleAdded,
];
